import { render, staticRenderFns } from "./banned.vue?vue&type=template&id=540002aa&scoped=true&"
import script from "./banned.vue?vue&type=script&lang=js&"
export * from "./banned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540002aa",
  null
  
)

export default component.exports